module.exports = {table:
{
  "*[AND,inlineShapeNot]" : {
     "AND": ["[AND,inlineShapeNot]","*[AND,inlineShapeNot]"], 
     "OR": [], 
     "%": [], 
     "//": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "*[AND,shapeNot]" : {
     "AND": ["[AND,shapeNot]","*[AND,shapeNot]"], 
     "OR": [], 
     ")": [], 
     "BASE": [], 
     "PREFIX": [], 
     "START": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "$": []}, 
  "*[OR,inlineShapeAnd]" : {
     "OR": ["[OR,inlineShapeAnd]","*[OR,inlineShapeAnd]"], 
     "%": [], 
     "//": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "*[OR,shapeAnd]" : {
     "OR": ["[OR,shapeAnd]","*[OR,shapeAnd]"], 
     ")": [], 
     "BASE": [], 
     "PREFIX": [], 
     "START": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "$": []}, 
  "*annotation" : {
     "//": ["annotation","*annotation"], 
     "OR": [], 
     "AND": [], 
     "%": [], 
     ")": [], 
     "|": [], 
     ";": [], 
     "BASE": [], 
     "PREFIX": [], 
     "START": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "}": [], 
     "$": []}, 
  "*codeDecl" : {
     "%": ["codeDecl","*codeDecl"], 
     "OR": [], 
     "AND": [], 
     ")": [], 
     "|": [], 
     ";": [], 
     "BASE": [], 
     "PREFIX": [], 
     "START": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "}": [], 
     "$": []}, 
  "*directive" : {
     "BASE": ["directive","*directive"], 
     "PREFIX": ["directive","*directive"], 
     "$": [], 
     "START": [], 
     "%": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": []}, 
  "*exclusion" : {
     "-": ["exclusion","*exclusion"], 
     ".": [], 
     "IRI_REF": [], 
     "INTEGER": [], 
     "DECIMAL": [], 
     "DOUBLE": [], 
     "TRUE": [], 
     "FALSE": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "STRING_LITERAL1": [], 
     "STRING_LITERAL_LONG1": [], 
     "STRING_LITERAL2": [], 
     "STRING_LITERAL_LONG2": [], 
     "]": []}, 
  "*or([extraPropertySet,CLOSED])" : {
     "CLOSED": ["or([extraPropertySet,CLOSED])","*or([extraPropertySet,CLOSED])"], 
     "EXTRA": ["or([extraPropertySet,CLOSED])","*or([extraPropertySet,CLOSED])"], 
     "{": []}, 
  "*predicate" : {
     "A": ["predicate","*predicate"], 
     "IRI_REF": ["predicate","*predicate"], 
     "PNAME_LN": ["predicate","*predicate"], 
     "PNAME_NS": ["predicate","*predicate"], 
     "CLOSED": [], 
     "EXTRA": [], 
     "{": []}, 
  "*statement" : {
     "BASE": ["statement","*statement"], 
     "PREFIX": ["statement","*statement"], 
     "START": ["statement","*statement"], 
     "IRI_REF": ["statement","*statement"], 
     "BLANK_NODE_LABEL": ["statement","*statement"], 
     "PNAME_LN": ["statement","*statement"], 
     "PNAME_NS": ["statement","*statement"], 
     "$": []}, 
  "*stringFacet" : {
     "REGEXP": ["stringFacet","*stringFacet"], 
     "LENGTH": ["stringFacet","*stringFacet"], 
     "MINLENGTH": ["stringFacet","*stringFacet"], 
     "MAXLENGTH": ["stringFacet","*stringFacet"], 
     "OR": [], 
     "AND": [], 
     "ATPNAME_NS": [], 
     "ATPNAME_LN": [], 
     "@": [], 
     "{": [], 
     "CLOSED": [], 
     "EXTRA": [], 
     ")": [], 
     "%": [], 
     "//": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "BASE": [], 
     "PREFIX": [], 
     "START": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "|": [], 
     ";": [], 
     "}": [], 
     "$": []}, 
  "*valueSetValue" : {
     ".": ["valueSetValue","*valueSetValue"], 
     "IRI_REF": ["valueSetValue","*valueSetValue"], 
     "INTEGER": ["valueSetValue","*valueSetValue"], 
     "DECIMAL": ["valueSetValue","*valueSetValue"], 
     "DOUBLE": ["valueSetValue","*valueSetValue"], 
     "TRUE": ["valueSetValue","*valueSetValue"], 
     "FALSE": ["valueSetValue","*valueSetValue"], 
     "PNAME_LN": ["valueSetValue","*valueSetValue"], 
     "PNAME_NS": ["valueSetValue","*valueSetValue"], 
     "STRING_LITERAL1": ["valueSetValue","*valueSetValue"], 
     "STRING_LITERAL_LONG1": ["valueSetValue","*valueSetValue"], 
     "STRING_LITERAL2": ["valueSetValue","*valueSetValue"], 
     "STRING_LITERAL_LONG2": ["valueSetValue","*valueSetValue"], 
     "]": []}, 
  "*xsFacet" : {
     "REGEXP": ["xsFacet","*xsFacet"], 
     "LENGTH": ["xsFacet","*xsFacet"], 
     "MINLENGTH": ["xsFacet","*xsFacet"], 
     "MAXLENGTH": ["xsFacet","*xsFacet"], 
     "MININCLUSIVE": ["xsFacet","*xsFacet"], 
     "MINEXCLUSIVE": ["xsFacet","*xsFacet"], 
     "MAXINCLUSIVE": ["xsFacet","*xsFacet"], 
     "MAXEXCLUSIVE": ["xsFacet","*xsFacet"], 
     "TOTALDIGITS": ["xsFacet","*xsFacet"], 
     "FRACTIONDIGITS": ["xsFacet","*xsFacet"], 
     "OR": [], 
     "AND": [], 
     "ATPNAME_NS": [], 
     "ATPNAME_LN": [], 
     "@": [], 
     "{": [], 
     "CLOSED": [], 
     "EXTRA": [], 
     ")": [], 
     "%": [], 
     "//": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "BASE": [], 
     "PREFIX": [], 
     "START": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "|": [], 
     ";": [], 
     "}": [], 
     "$": []}, 
  "+codeDecl" : {
     "%": ["codeDecl","*codeDecl"]}, 
  "+exclusion" : {
     "-": ["exclusion","*exclusion"]}, 
  "+predicate" : {
     "A": ["predicate","*predicate"], 
     "IRI_REF": ["predicate","*predicate"], 
     "PNAME_LN": ["predicate","*predicate"], 
     "PNAME_NS": ["predicate","*predicate"]}, 
  "+xsFacet" : {
     "REGEXP": ["xsFacet","*xsFacet"], 
     "LENGTH": ["xsFacet","*xsFacet"], 
     "MINLENGTH": ["xsFacet","*xsFacet"], 
     "MAXLENGTH": ["xsFacet","*xsFacet"], 
     "MININCLUSIVE": ["xsFacet","*xsFacet"], 
     "MINEXCLUSIVE": ["xsFacet","*xsFacet"], 
     "MAXINCLUSIVE": ["xsFacet","*xsFacet"], 
     "MAXEXCLUSIVE": ["xsFacet","*xsFacet"], 
     "TOTALDIGITS": ["xsFacet","*xsFacet"], 
     "FRACTIONDIGITS": ["xsFacet","*xsFacet"]}, 
  "?NOT" : {
     "NOT": ["NOT"], 
     "(": [], 
     ".": [], 
     "LITERAL": [], 
     "ATPNAME_NS": [], 
     "ATPNAME_LN": [], 
     "@": [], 
     "IRI": [], 
     "BNODE": [], 
     "NONLITERAL": [], 
     "[": [], 
     "{": [], 
     "CLOSED": [], 
     "IRI_REF": [], 
     "REGEXP": [], 
     "EXTRA": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "LENGTH": [], 
     "MINLENGTH": [], 
     "MAXLENGTH": [], 
     "MININCLUSIVE": [], 
     "MINEXCLUSIVE": [], 
     "MAXINCLUSIVE": [], 
     "MAXEXCLUSIVE": [], 
     "TOTALDIGITS": [], 
     "FRACTIONDIGITS": []}, 
  "?[or([notStartAction,startActions]),*statement]" : {
     "START": ["[or([notStartAction,startActions]),*statement]"], 
     "%": ["[or([notStartAction,startActions]),*statement]"], 
     "IRI_REF": ["[or([notStartAction,startActions]),*statement]"], 
     "BLANK_NODE_LABEL": ["[or([notStartAction,startActions]),*statement]"], 
     "PNAME_LN": ["[or([notStartAction,startActions]),*statement]"], 
     "PNAME_NS": ["[or([notStartAction,startActions]),*statement]"], 
     "$": []}, 
  "?[~,*exclusion]" : {
     "~": ["[~,*exclusion]"], 
     ".": [], 
     "IRI_REF": [], 
     "INTEGER": [], 
     "DECIMAL": [], 
     "DOUBLE": [], 
     "TRUE": [], 
     "FALSE": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "STRING_LITERAL1": [], 
     "STRING_LITERAL_LONG1": [], 
     "STRING_LITERAL2": [], 
     "STRING_LITERAL_LONG2": [], 
     "]": []}, 
  "?cardinality" : {
     "*": ["cardinality"], 
     "+": ["cardinality"], 
     "?": ["cardinality"], 
     "REPEAT_RANGE": ["cardinality"], 
     "%": [], 
     "//": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "?inlineShapeOrRef" : {
     "ATPNAME_NS": ["inlineShapeOrRef"], 
     "ATPNAME_LN": ["inlineShapeOrRef"], 
     "@": ["inlineShapeOrRef"], 
     "{": ["inlineShapeOrRef"], 
     "CLOSED": ["inlineShapeOrRef"], 
     "EXTRA": ["inlineShapeOrRef"], 
     "OR": [], 
     "AND": [], 
     "%": [], 
     "//": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "?nodeConstraint" : {
     "LITERAL": ["nodeConstraint"], 
     "IRI": ["nodeConstraint"], 
     "BNODE": ["nodeConstraint"], 
     "NONLITERAL": ["nodeConstraint"], 
     "[": ["nodeConstraint"], 
     "IRI_REF": ["nodeConstraint"], 
     "REGEXP": ["nodeConstraint"], 
     "PNAME_LN": ["nodeConstraint"], 
     "PNAME_NS": ["nodeConstraint"], 
     "LENGTH": ["nodeConstraint"], 
     "MINLENGTH": ["nodeConstraint"], 
     "MAXLENGTH": ["nodeConstraint"], 
     "MININCLUSIVE": ["nodeConstraint"], 
     "MINEXCLUSIVE": ["nodeConstraint"], 
     "MAXINCLUSIVE": ["nodeConstraint"], 
     "MAXEXCLUSIVE": ["nodeConstraint"], 
     "TOTALDIGITS": ["nodeConstraint"], 
     "FRACTIONDIGITS": ["nodeConstraint"], 
     "OR": [], 
     "AND": [], 
     "%": [], 
     "//": [], 
     "*": [], 
     "+": [], 
     "?": [], 
     "REPEAT_RANGE": [], 
     "|": [], 
     ";": [], 
     ")": [], 
     "}": []}, 
  "?or([LANGTAG,[^^,datatype]])" : {
     "LANGTAG": ["or([LANGTAG,[^^,datatype]])"], 
     "^^": ["or([LANGTAG,[^^,datatype]])"], 
     ".": [], 
     "IRI_REF": [], 
     "INTEGER": [], 
     "DECIMAL": [], 
     "DOUBLE": [], 
     "TRUE": [], 
     "FALSE": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "STRING_LITERAL1": [], 
     "STRING_LITERAL_LONG1": [], 
     "STRING_LITERAL2": [], 
     "STRING_LITERAL_LONG2": [], 
     "]": [], 
     "//": [], 
     "OR": [], 
     "AND": [], 
     "%": [], 
     ")": [], 
     "|": [], 
     ";": [], 
     "BASE": [], 
     "PREFIX": [], 
     "START": [], 
     "BLANK_NODE_LABEL": [], 
     "}": [], 
     "$": []}, 
  "?senseFlags" : {
     "^": ["senseFlags"], 
     "A": [], 
     "IRI_REF": [], 
     "PNAME_LN": [], 
     "PNAME_NS": []}, 
  "?shapeOrRef" : {
     "ATPNAME_NS": ["shapeOrRef"], 
     "ATPNAME_LN": ["shapeOrRef"], 
     "@": ["shapeOrRef"], 
     "{": ["shapeOrRef"], 
     "CLOSED": ["shapeOrRef"], 
     "EXTRA": ["shapeOrRef"], 
     "OR": [], 
     "AND": [], 
     ")": [], 
     "BASE": [], 
     "PREFIX": [], 
     "START": [], 
     "IRI_REF": [], 
     "BLANK_NODE_LABEL": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "$": []}, 
  "?tripleExprLabel" : {
     "$": ["tripleExprLabel"], 
     "(": [], 
     "A": [], 
     "^": [], 
     "IRI_REF": [], 
     "PNAME_LN": [], 
     "PNAME_NS": []}, 
  "?tripleExpression" : {
     "(": ["tripleExpression"], 
     "$": ["tripleExpression"], 
     "&": ["tripleExpression"], 
     "A": ["tripleExpression"], 
     "^": ["tripleExpression"], 
     "IRI_REF": ["tripleExpression"], 
     "PNAME_LN": ["tripleExpression"], 
     "PNAME_NS": ["tripleExpression"], 
     "}": []}, 
  "?~" : {
     "~": ["~"], 
     "-": [], 
     ".": [], 
     "IRI_REF": [], 
     "INTEGER": [], 
     "DECIMAL": [], 
     "DOUBLE": [], 
     "TRUE": [], 
     "FALSE": [], 
     "PNAME_LN": [], 
     "PNAME_NS": [], 
     "STRING_LITERAL1": [], 
     "STRING_LITERAL_LONG1": [], 
     "STRING_LITERAL2": [], 
     "STRING_LITERAL_LONG2": [], 
     "]": []}, 
  "[AND,inlineShapeNot]" : {
     "AND": ["AND","inlineShapeNot"]}, 
  "[AND,shapeNot]" : {
     "AND": ["AND","shapeNot"]}, 
  "[OR,inlineShapeAnd]" : {
     "OR": ["OR","inlineShapeAnd"]}, 
  "[OR,shapeAnd]" : {
     "OR": ["OR","shapeAnd"]}, 
  "[^^,datatype]" : {
     "^^": ["^^","datatype"]}, 
  "[or([notStartAction,startActions]),*statement]" : {
     "START": ["or([notStartAction,startActions])","*statement"], 
     "%": ["or([notStartAction,startActions])","*statement"], 
     "IRI_REF": ["or([notStartAction,startActions])","*statement"], 
     "BLANK_NODE_LABEL": ["or([notStartAction,startActions])","*statement"], 
     "PNAME_LN": ["or([notStartAction,startActions])","*statement"], 
     "PNAME_NS": ["or([notStartAction,startActions])","*statement"]}, 
  "[~,*exclusion]" : {
     "~": ["~","*exclusion"]}, 
  "annotation" : {
     "//": ["//","predicate","or([iri,literal])"]}, 
  "baseDecl" : {
     "BASE": ["BASE","IRI_REF"]}, 
  "blankNode" : {
     "BLANK_NODE_LABEL": ["BLANK_NODE_LABEL"]}, 
  "booleanLiteral" : {
     "TRUE": ["or([TRUE,FALSE])"], 
     "FALSE": ["or([TRUE,FALSE])"]}, 
  "bracketedTripleExpr" : {
     "(": ["(","tripleExpression",")","?cardinality","*annotation","semanticActions"]}, 
  "cardinality" : {
     "*": ["*"], 
     "+": ["+"], 
     "?": ["?"], 
     "REPEAT_RANGE": ["REPEAT_RANGE"]}, 
  "codeDecl" : {
     "%": ["%","iri","or([CODE,%])"]}, 
  "datatype" : {
     "IRI_REF": ["iri"], 
     "PNAME_LN": ["iri"], 
     "PNAME_NS": ["iri"]}, 
  "directive" : {
     "BASE": ["or([baseDecl,prefixDecl])"], 
     "PREFIX": ["or([baseDecl,prefixDecl])"]}, 
  "elementGroup" : {
     "(": ["unaryTripleExpr","singleElementGroup"], 
     "$": ["unaryTripleExpr","singleElementGroup"], 
     "&": ["unaryTripleExpr","singleElementGroup"], 
     "A": ["unaryTripleExpr","singleElementGroup"], 
     "^": ["unaryTripleExpr","singleElementGroup"], 
     "IRI_REF": ["unaryTripleExpr","singleElementGroup"], 
     "PNAME_LN": ["unaryTripleExpr","singleElementGroup"], 
     "PNAME_NS": ["unaryTripleExpr","singleElementGroup"], 
     "|": [], 
     ")": [], 
     "}": []}, 
  "exclusion" : {
     "-": ["-","iri","?~"]}, 
  "extraPropertySet" : {
     "EXTRA": ["EXTRA","+predicate"]}, 
  "fmulti" : {
     "|": ["|","unaryTripleExpr","singleElementGroup","fmulti"], 
     ")": [], 
     "}": []}, 
  "fsingle" : {
     "|": ["|","unaryTripleExpr","singleElementGroup","fmulti"], 
     ")": [], 
     "}": []}, 
  "funaryTripleExpr" : {
     "|": ["singleElementGroup","fsingle"], 
     ";": ["singleElementGroup","fsingle"], 
     ")": ["singleElementGroup","fsingle"], 
     "}": ["singleElementGroup","fsingle"]}, 
  "include" : {
     "&": ["&","tripleExprLabel"]}, 
  "inlineShapeAnd" : {
     "NOT": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "(": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     ".": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "LITERAL": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "ATPNAME_NS": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "ATPNAME_LN": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "@": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "IRI": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "BNODE": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "NONLITERAL": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "[": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "{": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "CLOSED": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "IRI_REF": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "REGEXP": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "EXTRA": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "PNAME_LN": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "PNAME_NS": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "LENGTH": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "MINLENGTH": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "MAXLENGTH": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "MININCLUSIVE": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "MINEXCLUSIVE": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "MAXINCLUSIVE": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "MAXEXCLUSIVE": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "TOTALDIGITS": ["inlineShapeNot","*[AND,inlineShapeNot]"], 
     "FRACTIONDIGITS": ["inlineShapeNot","*[AND,inlineShapeNot]"]}, 
  "inlineShapeAtom" : {
     "LITERAL": ["nodeConstraint","?inlineShapeOrRef"], 
     "IRI": ["nodeConstraint","?inlineShapeOrRef"], 
     "BNODE": ["nodeConstraint","?inlineShapeOrRef"], 
     "NONLITERAL": ["nodeConstraint","?inlineShapeOrRef"], 
     "[": ["nodeConstraint","?inlineShapeOrRef"], 
     "IRI_REF": ["nodeConstraint","?inlineShapeOrRef"], 
     "REGEXP": ["nodeConstraint","?inlineShapeOrRef"], 
     "PNAME_LN": ["nodeConstraint","?inlineShapeOrRef"], 
     "PNAME_NS": ["nodeConstraint","?inlineShapeOrRef"], 
     "LENGTH": ["nodeConstraint","?inlineShapeOrRef"], 
     "MINLENGTH": ["nodeConstraint","?inlineShapeOrRef"], 
     "MAXLENGTH": ["nodeConstraint","?inlineShapeOrRef"], 
     "MININCLUSIVE": ["nodeConstraint","?inlineShapeOrRef"], 
     "MINEXCLUSIVE": ["nodeConstraint","?inlineShapeOrRef"], 
     "MAXINCLUSIVE": ["nodeConstraint","?inlineShapeOrRef"], 
     "MAXEXCLUSIVE": ["nodeConstraint","?inlineShapeOrRef"], 
     "TOTALDIGITS": ["nodeConstraint","?inlineShapeOrRef"], 
     "FRACTIONDIGITS": ["nodeConstraint","?inlineShapeOrRef"], 
     "ATPNAME_NS": ["inlineShapeOrRef","?nodeConstraint"], 
     "ATPNAME_LN": ["inlineShapeOrRef","?nodeConstraint"], 
     "@": ["inlineShapeOrRef","?nodeConstraint"], 
     "{": ["inlineShapeOrRef","?nodeConstraint"], 
     "CLOSED": ["inlineShapeOrRef","?nodeConstraint"], 
     "EXTRA": ["inlineShapeOrRef","?nodeConstraint"], 
     "(": ["(","shapeExpression",")"], 
     ".": ["."]}, 
  "inlineShapeDefinition" : {
     "{": ["*or([extraPropertySet,CLOSED])","{","?tripleExpression","}"], 
     "CLOSED": ["*or([extraPropertySet,CLOSED])","{","?tripleExpression","}"], 
     "EXTRA": ["*or([extraPropertySet,CLOSED])","{","?tripleExpression","}"]}, 
  "inlineShapeExpression" : {
     "NOT": ["inlineShapeOr"], 
     "(": ["inlineShapeOr"], 
     ".": ["inlineShapeOr"], 
     "LITERAL": ["inlineShapeOr"], 
     "ATPNAME_NS": ["inlineShapeOr"], 
     "ATPNAME_LN": ["inlineShapeOr"], 
     "@": ["inlineShapeOr"], 
     "IRI": ["inlineShapeOr"], 
     "BNODE": ["inlineShapeOr"], 
     "NONLITERAL": ["inlineShapeOr"], 
     "[": ["inlineShapeOr"], 
     "{": ["inlineShapeOr"], 
     "CLOSED": ["inlineShapeOr"], 
     "IRI_REF": ["inlineShapeOr"], 
     "REGEXP": ["inlineShapeOr"], 
     "EXTRA": ["inlineShapeOr"], 
     "PNAME_LN": ["inlineShapeOr"], 
     "PNAME_NS": ["inlineShapeOr"], 
     "LENGTH": ["inlineShapeOr"], 
     "MINLENGTH": ["inlineShapeOr"], 
     "MAXLENGTH": ["inlineShapeOr"], 
     "MININCLUSIVE": ["inlineShapeOr"], 
     "MINEXCLUSIVE": ["inlineShapeOr"], 
     "MAXINCLUSIVE": ["inlineShapeOr"], 
     "MAXEXCLUSIVE": ["inlineShapeOr"], 
     "TOTALDIGITS": ["inlineShapeOr"], 
     "FRACTIONDIGITS": ["inlineShapeOr"]}, 
  "inlineShapeNot" : {
     "(": ["?NOT","inlineShapeAtom"], 
     ".": ["?NOT","inlineShapeAtom"], 
     "LITERAL": ["?NOT","inlineShapeAtom"], 
     "ATPNAME_NS": ["?NOT","inlineShapeAtom"], 
     "ATPNAME_LN": ["?NOT","inlineShapeAtom"], 
     "@": ["?NOT","inlineShapeAtom"], 
     "IRI": ["?NOT","inlineShapeAtom"], 
     "BNODE": ["?NOT","inlineShapeAtom"], 
     "NONLITERAL": ["?NOT","inlineShapeAtom"], 
     "[": ["?NOT","inlineShapeAtom"], 
     "{": ["?NOT","inlineShapeAtom"], 
     "CLOSED": ["?NOT","inlineShapeAtom"], 
     "IRI_REF": ["?NOT","inlineShapeAtom"], 
     "REGEXP": ["?NOT","inlineShapeAtom"], 
     "EXTRA": ["?NOT","inlineShapeAtom"], 
     "PNAME_LN": ["?NOT","inlineShapeAtom"], 
     "PNAME_NS": ["?NOT","inlineShapeAtom"], 
     "LENGTH": ["?NOT","inlineShapeAtom"], 
     "MINLENGTH": ["?NOT","inlineShapeAtom"], 
     "MAXLENGTH": ["?NOT","inlineShapeAtom"], 
     "MININCLUSIVE": ["?NOT","inlineShapeAtom"], 
     "MINEXCLUSIVE": ["?NOT","inlineShapeAtom"], 
     "MAXINCLUSIVE": ["?NOT","inlineShapeAtom"], 
     "MAXEXCLUSIVE": ["?NOT","inlineShapeAtom"], 
     "TOTALDIGITS": ["?NOT","inlineShapeAtom"], 
     "FRACTIONDIGITS": ["?NOT","inlineShapeAtom"], 
     "NOT": ["?NOT","inlineShapeAtom"]}, 
  "inlineShapeOr" : {
     "NOT": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "(": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     ".": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "LITERAL": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "ATPNAME_NS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "ATPNAME_LN": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "@": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "IRI": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "BNODE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "NONLITERAL": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "[": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "{": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "CLOSED": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "IRI_REF": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "REGEXP": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "EXTRA": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "PNAME_LN": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "PNAME_NS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "LENGTH": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MINLENGTH": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MAXLENGTH": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MININCLUSIVE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MINEXCLUSIVE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MAXINCLUSIVE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "MAXEXCLUSIVE": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "TOTALDIGITS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"], 
     "FRACTIONDIGITS": ["inlineShapeAnd","*[OR,inlineShapeAnd]"]}, 
  "inlineShapeOrRef" : {
     "{": ["inlineShapeDefinition"], 
     "CLOSED": ["inlineShapeDefinition"], 
     "EXTRA": ["inlineShapeDefinition"], 
     "ATPNAME_NS": ["ATPNAME_NS"], 
     "ATPNAME_LN": ["ATPNAME_LN"], 
     "@": ["@","shapeExprLabel"]}, 
  "iri" : {
     "IRI_REF": ["or([IRI_REF,prefixedName])"], 
     "PNAME_LN": ["or([IRI_REF,prefixedName])"], 
     "PNAME_NS": ["or([IRI_REF,prefixedName])"]}, 
  "iriRange" : {
     "IRI_REF": ["iri","?[~,*exclusion]"], 
     "PNAME_LN": ["iri","?[~,*exclusion]"], 
     "PNAME_NS": ["iri","?[~,*exclusion]"], 
     ".": [".","+exclusion"]}, 
  "literal" : {
     "INTEGER": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "DECIMAL": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "DOUBLE": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "TRUE": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "FALSE": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "STRING_LITERAL1": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "STRING_LITERAL_LONG1": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "STRING_LITERAL2": ["or([rdfLiteral,numericLiteral,booleanLiteral])"], 
     "STRING_LITERAL_LONG2": ["or([rdfLiteral,numericLiteral,booleanLiteral])"]}, 
  "nodeConstraint" : {
     "LITERAL": ["LITERAL","*stringFacet"], 
     "IRI": ["nonLiteralKind","*xsFacet"], 
     "BNODE": ["nonLiteralKind","*xsFacet"], 
     "NONLITERAL": ["nonLiteralKind","*xsFacet"], 
     "IRI_REF": ["datatype","*xsFacet"], 
     "PNAME_LN": ["datatype","*xsFacet"], 
     "PNAME_NS": ["datatype","*xsFacet"], 
     "[": ["valueSet","*xsFacet"], 
     "REGEXP": ["+xsFacet"], 
     "LENGTH": ["+xsFacet"], 
     "MINLENGTH": ["+xsFacet"], 
     "MAXLENGTH": ["+xsFacet"], 
     "MININCLUSIVE": ["+xsFacet"], 
     "MINEXCLUSIVE": ["+xsFacet"], 
     "MAXINCLUSIVE": ["+xsFacet"], 
     "MAXEXCLUSIVE": ["+xsFacet"], 
     "TOTALDIGITS": ["+xsFacet"], 
     "FRACTIONDIGITS": ["+xsFacet"]}, 
  "nonLiteralKind" : {
     "IRI": ["IRI"], 
     "BNODE": ["BNODE"], 
     "NONLITERAL": ["NONLITERAL"]}, 
  "notStartAction" : {
     "START": ["or([startt,shapeExprDecl])"], 
     "IRI_REF": ["or([startt,shapeExprDecl])"], 
     "BLANK_NODE_LABEL": ["or([startt,shapeExprDecl])"], 
     "PNAME_LN": ["or([startt,shapeExprDecl])"], 
     "PNAME_NS": ["or([startt,shapeExprDecl])"]}, 
  "numericFacet" : {
     "MININCLUSIVE": ["numericRange","numericLiteral"], 
     "MINEXCLUSIVE": ["numericRange","numericLiteral"], 
     "MAXINCLUSIVE": ["numericRange","numericLiteral"], 
     "MAXEXCLUSIVE": ["numericRange","numericLiteral"], 
     "TOTALDIGITS": ["numericLength","INTEGER"], 
     "FRACTIONDIGITS": ["numericLength","INTEGER"]}, 
  "numericLength" : {
     "TOTALDIGITS": ["TOTALDIGITS"], 
     "FRACTIONDIGITS": ["FRACTIONDIGITS"]}, 
  "numericLiteral" : {
     "INTEGER": ["INTEGER"], 
     "DECIMAL": ["DECIMAL"], 
     "DOUBLE": ["DOUBLE"]}, 
  "numericRange" : {
     "MININCLUSIVE": ["MININCLUSIVE"], 
     "MINEXCLUSIVE": ["MINEXCLUSIVE"], 
     "MAXINCLUSIVE": ["MAXINCLUSIVE"], 
     "MAXEXCLUSIVE": ["MAXEXCLUSIVE"]}, 
  "oneOfTripleExpr" : {
     "(": ["unaryTripleExpr","funaryTripleExpr"], 
     "$": ["unaryTripleExpr","funaryTripleExpr"], 
     "&": ["unaryTripleExpr","funaryTripleExpr"], 
     "A": ["unaryTripleExpr","funaryTripleExpr"], 
     "^": ["unaryTripleExpr","funaryTripleExpr"], 
     "IRI_REF": ["unaryTripleExpr","funaryTripleExpr"], 
     "PNAME_LN": ["unaryTripleExpr","funaryTripleExpr"], 
     "PNAME_NS": ["unaryTripleExpr","funaryTripleExpr"]}, 
  "or([CODE,%])" : {
     "CODE": ["CODE"], 
     "%": ["%"]}, 
  "or([IRI_REF,prefixedName])" : {
     "IRI_REF": ["IRI_REF"], 
     "PNAME_LN": ["prefixedName"], 
     "PNAME_NS": ["prefixedName"]}, 
  "or([LANGTAG,[^^,datatype]])" : {
     "LANGTAG": ["LANGTAG"], 
     "^^": ["[^^,datatype]"]}, 
  "or([PNAME_LN,PNAME_NS])" : {
     "PNAME_LN": ["PNAME_LN"], 
     "PNAME_NS": ["PNAME_NS"]}, 
  "or([TRUE,FALSE])" : {
     "TRUE": ["TRUE"], 
     "FALSE": ["FALSE"]}, 
  "or([baseDecl,prefixDecl])" : {
     "BASE": ["baseDecl"], 
     "PREFIX": ["prefixDecl"]}, 
  "or([directive,notStartAction])" : {
     "BASE": ["directive"], 
     "PREFIX": ["directive"], 
     "START": ["notStartAction"], 
     "IRI_REF": ["notStartAction"], 
     "BLANK_NODE_LABEL": ["notStartAction"], 
     "PNAME_LN": ["notStartAction"], 
     "PNAME_NS": ["notStartAction"]}, 
  "or([extraPropertySet,CLOSED])" : {
     "EXTRA": ["extraPropertySet"], 
     "CLOSED": ["CLOSED"]}, 
  "or([iri,A])" : {
     "IRI_REF": ["iri"], 
     "PNAME_LN": ["iri"], 
     "PNAME_NS": ["iri"], 
     "A": ["A"]}, 
  "or([iri,blankNode])" : {
     "IRI_REF": ["iri"], 
     "PNAME_LN": ["iri"], 
     "PNAME_NS": ["iri"], 
     "BLANK_NODE_LABEL": ["blankNode"]}, 
  "or([iri,literal])" : {
     "IRI_REF": ["iri"], 
     "PNAME_LN": ["iri"], 
     "PNAME_NS": ["iri"], 
     "INTEGER": ["literal"], 
     "DECIMAL": ["literal"], 
     "DOUBLE": ["literal"], 
     "TRUE": ["literal"], 
     "FALSE": ["literal"], 
     "STRING_LITERAL1": ["literal"], 
     "STRING_LITERAL_LONG1": ["literal"], 
     "STRING_LITERAL2": ["literal"], 
     "STRING_LITERAL_LONG2": ["literal"]}, 
  "or([notStartAction,startActions])" : {
     "START": ["notStartAction"], 
     "IRI_REF": ["notStartAction"], 
     "BLANK_NODE_LABEL": ["notStartAction"], 
     "PNAME_LN": ["notStartAction"], 
     "PNAME_NS": ["notStartAction"], 
     "%": ["startActions"]}, 
  "or([rdfLiteral,numericLiteral,booleanLiteral])" : {
     "STRING_LITERAL1": ["rdfLiteral"], 
     "STRING_LITERAL_LONG1": ["rdfLiteral"], 
     "STRING_LITERAL2": ["rdfLiteral"], 
     "STRING_LITERAL_LONG2": ["rdfLiteral"], 
     "INTEGER": ["numericLiteral"], 
     "DECIMAL": ["numericLiteral"], 
     "DOUBLE": ["numericLiteral"], 
     "TRUE": ["booleanLiteral"], 
     "FALSE": ["booleanLiteral"]}, 
  "or([shapeExpression,EXTERNAL])" : {
     "NOT": ["shapeExpression"], 
     "(": ["shapeExpression"], 
     ".": ["shapeExpression"], 
     "LITERAL": ["shapeExpression"], 
     "ATPNAME_NS": ["shapeExpression"], 
     "ATPNAME_LN": ["shapeExpression"], 
     "@": ["shapeExpression"], 
     "IRI": ["shapeExpression"], 
     "BNODE": ["shapeExpression"], 
     "NONLITERAL": ["shapeExpression"], 
     "[": ["shapeExpression"], 
     "{": ["shapeExpression"], 
     "CLOSED": ["shapeExpression"], 
     "IRI_REF": ["shapeExpression"], 
     "REGEXP": ["shapeExpression"], 
     "EXTRA": ["shapeExpression"], 
     "PNAME_LN": ["shapeExpression"], 
     "PNAME_NS": ["shapeExpression"], 
     "LENGTH": ["shapeExpression"], 
     "MINLENGTH": ["shapeExpression"], 
     "MAXLENGTH": ["shapeExpression"], 
     "MININCLUSIVE": ["shapeExpression"], 
     "MINEXCLUSIVE": ["shapeExpression"], 
     "MAXINCLUSIVE": ["shapeExpression"], 
     "MAXEXCLUSIVE": ["shapeExpression"], 
     "TOTALDIGITS": ["shapeExpression"], 
     "FRACTIONDIGITS": ["shapeExpression"], 
     "EXTERNAL": ["EXTERNAL"]}, 
  "or([startt,shapeExprDecl])" : {
     "START": ["startt"], 
     "IRI_REF": ["shapeExprDecl"], 
     "BLANK_NODE_LABEL": ["shapeExprDecl"], 
     "PNAME_LN": ["shapeExprDecl"], 
     "PNAME_NS": ["shapeExprDecl"]}, 
  "or([stringFacet,numericFacet])" : {
     "REGEXP": ["stringFacet"], 
     "LENGTH": ["stringFacet"], 
     "MINLENGTH": ["stringFacet"], 
     "MAXLENGTH": ["stringFacet"], 
     "MININCLUSIVE": ["numericFacet"], 
     "MINEXCLUSIVE": ["numericFacet"], 
     "MAXINCLUSIVE": ["numericFacet"], 
     "MAXEXCLUSIVE": ["numericFacet"], 
     "TOTALDIGITS": ["numericFacet"], 
     "FRACTIONDIGITS": ["numericFacet"]}, 
  "or([tripleConstraint,bracketedTripleExpr])" : {
     "A": ["tripleConstraint"], 
     "^": ["tripleConstraint"], 
     "IRI_REF": ["tripleConstraint"], 
     "PNAME_LN": ["tripleConstraint"], 
     "PNAME_NS": ["tripleConstraint"], 
     "(": ["bracketedTripleExpr"]}, 
  "predicate" : {
     "A": ["or([iri,A])"], 
     "IRI_REF": ["or([iri,A])"], 
     "PNAME_LN": ["or([iri,A])"], 
     "PNAME_NS": ["or([iri,A])"]}, 
  "prefixDecl" : {
     "PREFIX": ["PREFIX","PNAME_NS","IRI_REF"]}, 
  "prefixedName" : {
     "PNAME_LN": ["or([PNAME_LN,PNAME_NS])"], 
     "PNAME_NS": ["or([PNAME_LN,PNAME_NS])"]}, 
  "rdfLiteral" : {
     "STRING_LITERAL1": ["string","?or([LANGTAG,[^^,datatype]])"], 
     "STRING_LITERAL_LONG1": ["string","?or([LANGTAG,[^^,datatype]])"], 
     "STRING_LITERAL2": ["string","?or([LANGTAG,[^^,datatype]])"], 
     "STRING_LITERAL_LONG2": ["string","?or([LANGTAG,[^^,datatype]])"]}, 
  "semanticActions" : {
     "%": ["*codeDecl"], 
     "OR": ["*codeDecl"], 
     "AND": ["*codeDecl"], 
     ")": ["*codeDecl"], 
     "|": ["*codeDecl"], 
     ";": ["*codeDecl"], 
     "BASE": ["*codeDecl"], 
     "PREFIX": ["*codeDecl"], 
     "START": ["*codeDecl"], 
     "IRI_REF": ["*codeDecl"], 
     "BLANK_NODE_LABEL": ["*codeDecl"], 
     "PNAME_LN": ["*codeDecl"], 
     "PNAME_NS": ["*codeDecl"], 
     "}": ["*codeDecl"], 
     "$": ["*codeDecl"]}, 
  "senseFlags" : {
     "^": ["^"]}, 
  "shapeAnd" : {
     "NOT": ["shapeNot","*[AND,shapeNot]"], 
     "(": ["shapeNot","*[AND,shapeNot]"], 
     ".": ["shapeNot","*[AND,shapeNot]"], 
     "LITERAL": ["shapeNot","*[AND,shapeNot]"], 
     "ATPNAME_NS": ["shapeNot","*[AND,shapeNot]"], 
     "ATPNAME_LN": ["shapeNot","*[AND,shapeNot]"], 
     "@": ["shapeNot","*[AND,shapeNot]"], 
     "IRI": ["shapeNot","*[AND,shapeNot]"], 
     "BNODE": ["shapeNot","*[AND,shapeNot]"], 
     "NONLITERAL": ["shapeNot","*[AND,shapeNot]"], 
     "[": ["shapeNot","*[AND,shapeNot]"], 
     "{": ["shapeNot","*[AND,shapeNot]"], 
     "CLOSED": ["shapeNot","*[AND,shapeNot]"], 
     "IRI_REF": ["shapeNot","*[AND,shapeNot]"], 
     "REGEXP": ["shapeNot","*[AND,shapeNot]"], 
     "EXTRA": ["shapeNot","*[AND,shapeNot]"], 
     "PNAME_LN": ["shapeNot","*[AND,shapeNot]"], 
     "PNAME_NS": ["shapeNot","*[AND,shapeNot]"], 
     "LENGTH": ["shapeNot","*[AND,shapeNot]"], 
     "MINLENGTH": ["shapeNot","*[AND,shapeNot]"], 
     "MAXLENGTH": ["shapeNot","*[AND,shapeNot]"], 
     "MININCLUSIVE": ["shapeNot","*[AND,shapeNot]"], 
     "MINEXCLUSIVE": ["shapeNot","*[AND,shapeNot]"], 
     "MAXINCLUSIVE": ["shapeNot","*[AND,shapeNot]"], 
     "MAXEXCLUSIVE": ["shapeNot","*[AND,shapeNot]"], 
     "TOTALDIGITS": ["shapeNot","*[AND,shapeNot]"], 
     "FRACTIONDIGITS": ["shapeNot","*[AND,shapeNot]"]}, 
  "shapeAtom" : {
     "LITERAL": ["nodeConstraint","?shapeOrRef"], 
     "IRI": ["nodeConstraint","?shapeOrRef"], 
     "BNODE": ["nodeConstraint","?shapeOrRef"], 
     "NONLITERAL": ["nodeConstraint","?shapeOrRef"], 
     "[": ["nodeConstraint","?shapeOrRef"], 
     "IRI_REF": ["nodeConstraint","?shapeOrRef"], 
     "REGEXP": ["nodeConstraint","?shapeOrRef"], 
     "PNAME_LN": ["nodeConstraint","?shapeOrRef"], 
     "PNAME_NS": ["nodeConstraint","?shapeOrRef"], 
     "LENGTH": ["nodeConstraint","?shapeOrRef"], 
     "MINLENGTH": ["nodeConstraint","?shapeOrRef"], 
     "MAXLENGTH": ["nodeConstraint","?shapeOrRef"], 
     "MININCLUSIVE": ["nodeConstraint","?shapeOrRef"], 
     "MINEXCLUSIVE": ["nodeConstraint","?shapeOrRef"], 
     "MAXINCLUSIVE": ["nodeConstraint","?shapeOrRef"], 
     "MAXEXCLUSIVE": ["nodeConstraint","?shapeOrRef"], 
     "TOTALDIGITS": ["nodeConstraint","?shapeOrRef"], 
     "FRACTIONDIGITS": ["nodeConstraint","?shapeOrRef"], 
     "ATPNAME_NS": ["shapeOrRef"], 
     "ATPNAME_LN": ["shapeOrRef"], 
     "@": ["shapeOrRef"], 
     "{": ["shapeOrRef"], 
     "CLOSED": ["shapeOrRef"], 
     "EXTRA": ["shapeOrRef"], 
     "(": ["(","shapeExpression",")"], 
     ".": ["."]}, 
  "shapeDefinition" : {
     "{": ["*or([extraPropertySet,CLOSED])","{","?tripleExpression","}","*annotation","semanticActions"], 
     "CLOSED": ["*or([extraPropertySet,CLOSED])","{","?tripleExpression","}","*annotation","semanticActions"], 
     "EXTRA": ["*or([extraPropertySet,CLOSED])","{","?tripleExpression","}","*annotation","semanticActions"]}, 
  "shapeExprDecl" : {
     "IRI_REF": ["shapeExprLabel","or([shapeExpression,EXTERNAL])"], 
     "BLANK_NODE_LABEL": ["shapeExprLabel","or([shapeExpression,EXTERNAL])"], 
     "PNAME_LN": ["shapeExprLabel","or([shapeExpression,EXTERNAL])"], 
     "PNAME_NS": ["shapeExprLabel","or([shapeExpression,EXTERNAL])"]}, 
  "shapeExprLabel" : {
     "IRI_REF": ["or([iri,blankNode])"], 
     "BLANK_NODE_LABEL": ["or([iri,blankNode])"], 
     "PNAME_LN": ["or([iri,blankNode])"], 
     "PNAME_NS": ["or([iri,blankNode])"]}, 
  "shapeExpression" : {
     "NOT": ["shapeOr"], 
     "(": ["shapeOr"], 
     ".": ["shapeOr"], 
     "LITERAL": ["shapeOr"], 
     "ATPNAME_NS": ["shapeOr"], 
     "ATPNAME_LN": ["shapeOr"], 
     "@": ["shapeOr"], 
     "IRI": ["shapeOr"], 
     "BNODE": ["shapeOr"], 
     "NONLITERAL": ["shapeOr"], 
     "[": ["shapeOr"], 
     "{": ["shapeOr"], 
     "CLOSED": ["shapeOr"], 
     "IRI_REF": ["shapeOr"], 
     "REGEXP": ["shapeOr"], 
     "EXTRA": ["shapeOr"], 
     "PNAME_LN": ["shapeOr"], 
     "PNAME_NS": ["shapeOr"], 
     "LENGTH": ["shapeOr"], 
     "MINLENGTH": ["shapeOr"], 
     "MAXLENGTH": ["shapeOr"], 
     "MININCLUSIVE": ["shapeOr"], 
     "MINEXCLUSIVE": ["shapeOr"], 
     "MAXINCLUSIVE": ["shapeOr"], 
     "MAXEXCLUSIVE": ["shapeOr"], 
     "TOTALDIGITS": ["shapeOr"], 
     "FRACTIONDIGITS": ["shapeOr"]}, 
  "shapeNot" : {
     "(": ["?NOT","shapeAtom"], 
     ".": ["?NOT","shapeAtom"], 
     "LITERAL": ["?NOT","shapeAtom"], 
     "ATPNAME_NS": ["?NOT","shapeAtom"], 
     "ATPNAME_LN": ["?NOT","shapeAtom"], 
     "@": ["?NOT","shapeAtom"], 
     "IRI": ["?NOT","shapeAtom"], 
     "BNODE": ["?NOT","shapeAtom"], 
     "NONLITERAL": ["?NOT","shapeAtom"], 
     "[": ["?NOT","shapeAtom"], 
     "{": ["?NOT","shapeAtom"], 
     "CLOSED": ["?NOT","shapeAtom"], 
     "IRI_REF": ["?NOT","shapeAtom"], 
     "REGEXP": ["?NOT","shapeAtom"], 
     "EXTRA": ["?NOT","shapeAtom"], 
     "PNAME_LN": ["?NOT","shapeAtom"], 
     "PNAME_NS": ["?NOT","shapeAtom"], 
     "LENGTH": ["?NOT","shapeAtom"], 
     "MINLENGTH": ["?NOT","shapeAtom"], 
     "MAXLENGTH": ["?NOT","shapeAtom"], 
     "MININCLUSIVE": ["?NOT","shapeAtom"], 
     "MINEXCLUSIVE": ["?NOT","shapeAtom"], 
     "MAXINCLUSIVE": ["?NOT","shapeAtom"], 
     "MAXEXCLUSIVE": ["?NOT","shapeAtom"], 
     "TOTALDIGITS": ["?NOT","shapeAtom"], 
     "FRACTIONDIGITS": ["?NOT","shapeAtom"], 
     "NOT": ["?NOT","shapeAtom"]}, 
  "shapeOr" : {
     "NOT": ["shapeAnd","*[OR,shapeAnd]"], 
     "(": ["shapeAnd","*[OR,shapeAnd]"], 
     ".": ["shapeAnd","*[OR,shapeAnd]"], 
     "LITERAL": ["shapeAnd","*[OR,shapeAnd]"], 
     "ATPNAME_NS": ["shapeAnd","*[OR,shapeAnd]"], 
     "ATPNAME_LN": ["shapeAnd","*[OR,shapeAnd]"], 
     "@": ["shapeAnd","*[OR,shapeAnd]"], 
     "IRI": ["shapeAnd","*[OR,shapeAnd]"], 
     "BNODE": ["shapeAnd","*[OR,shapeAnd]"], 
     "NONLITERAL": ["shapeAnd","*[OR,shapeAnd]"], 
     "[": ["shapeAnd","*[OR,shapeAnd]"], 
     "{": ["shapeAnd","*[OR,shapeAnd]"], 
     "CLOSED": ["shapeAnd","*[OR,shapeAnd]"], 
     "IRI_REF": ["shapeAnd","*[OR,shapeAnd]"], 
     "REGEXP": ["shapeAnd","*[OR,shapeAnd]"], 
     "EXTRA": ["shapeAnd","*[OR,shapeAnd]"], 
     "PNAME_LN": ["shapeAnd","*[OR,shapeAnd]"], 
     "PNAME_NS": ["shapeAnd","*[OR,shapeAnd]"], 
     "LENGTH": ["shapeAnd","*[OR,shapeAnd]"], 
     "MINLENGTH": ["shapeAnd","*[OR,shapeAnd]"], 
     "MAXLENGTH": ["shapeAnd","*[OR,shapeAnd]"], 
     "MININCLUSIVE": ["shapeAnd","*[OR,shapeAnd]"], 
     "MINEXCLUSIVE": ["shapeAnd","*[OR,shapeAnd]"], 
     "MAXINCLUSIVE": ["shapeAnd","*[OR,shapeAnd]"], 
     "MAXEXCLUSIVE": ["shapeAnd","*[OR,shapeAnd]"], 
     "TOTALDIGITS": ["shapeAnd","*[OR,shapeAnd]"], 
     "FRACTIONDIGITS": ["shapeAnd","*[OR,shapeAnd]"]}, 
  "shapeOrRef" : {
     "{": ["shapeDefinition"], 
     "CLOSED": ["shapeDefinition"], 
     "EXTRA": ["shapeDefinition"], 
     "ATPNAME_NS": ["ATPNAME_NS"], 
     "ATPNAME_LN": ["ATPNAME_LN"], 
     "@": ["@","shapeExprLabel"]}, 
  "shexDoC" : {
     "$": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "START": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "%": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "IRI_REF": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "BLANK_NODE_LABEL": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "PNAME_LN": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "PNAME_NS": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "BASE": ["*directive","?[or([notStartAction,startActions]),*statement]","$"], 
     "PREFIX": ["*directive","?[or([notStartAction,startActions]),*statement]","$"]}, 
  "singleElementGroup" : {
     ";": [";","elementGroup"], 
     "|": [], 
     ")": [], 
     "}": []}, 
  "startActions" : {
     "%": ["+codeDecl"]}, 
  "startt" : {
     "START": ["START","=","shapeExpression"]}, 
  "statement" : {
     "BASE": ["or([directive,notStartAction])"], 
     "PREFIX": ["or([directive,notStartAction])"], 
     "START": ["or([directive,notStartAction])"], 
     "IRI_REF": ["or([directive,notStartAction])"], 
     "BLANK_NODE_LABEL": ["or([directive,notStartAction])"], 
     "PNAME_LN": ["or([directive,notStartAction])"], 
     "PNAME_NS": ["or([directive,notStartAction])"]}, 
  "string" : {
     "STRING_LITERAL1": ["STRING_LITERAL1"], 
     "STRING_LITERAL_LONG1": ["STRING_LITERAL_LONG1"], 
     "STRING_LITERAL2": ["STRING_LITERAL2"], 
     "STRING_LITERAL_LONG2": ["STRING_LITERAL_LONG2"]}, 
  "stringFacet" : {
     "LENGTH": ["stringLength","INTEGER"], 
     "MINLENGTH": ["stringLength","INTEGER"], 
     "MAXLENGTH": ["stringLength","INTEGER"], 
     "REGEXP": ["REGEXP"]}, 
  "stringLength" : {
     "LENGTH": ["LENGTH"], 
     "MINLENGTH": ["MINLENGTH"], 
     "MAXLENGTH": ["MAXLENGTH"]}, 
  "tripleConstraint" : {
     "A": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"], 
     "IRI_REF": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"], 
     "PNAME_LN": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"], 
     "PNAME_NS": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"], 
     "^": ["?senseFlags","predicate","inlineShapeExpression","?cardinality","*annotation","semanticActions"]}, 
  "tripleExprLabel" : {
     "$": ["$","or([iri,blankNode])"]}, 
  "tripleExpression" : {
     "(": ["oneOfTripleExpr"], 
     "$": ["oneOfTripleExpr"], 
     "&": ["oneOfTripleExpr"], 
     "A": ["oneOfTripleExpr"], 
     "^": ["oneOfTripleExpr"], 
     "IRI_REF": ["oneOfTripleExpr"], 
     "PNAME_LN": ["oneOfTripleExpr"], 
     "PNAME_NS": ["oneOfTripleExpr"]}, 
  "unaryTripleExpr" : {
     "(": ["?tripleExprLabel","or([tripleConstraint,bracketedTripleExpr])"], 
     "A": ["?tripleExprLabel","or([tripleConstraint,bracketedTripleExpr])"], 
     "^": ["?tripleExprLabel","or([tripleConstraint,bracketedTripleExpr])"], 
     "IRI_REF": ["?tripleExprLabel","or([tripleConstraint,bracketedTripleExpr])"], 
     "PNAME_LN": ["?tripleExprLabel","or([tripleConstraint,bracketedTripleExpr])"], 
     "PNAME_NS": ["?tripleExprLabel","or([tripleConstraint,bracketedTripleExpr])"], 
     "$": ["?tripleExprLabel","or([tripleConstraint,bracketedTripleExpr])"], 
     "&": ["include"]}, 
  "valueSet" : {
     "[": ["[","*valueSetValue","]"]}, 
  "valueSetValue" : {
     ".": ["iriRange"], 
     "IRI_REF": ["iriRange"], 
     "PNAME_LN": ["iriRange"], 
     "PNAME_NS": ["iriRange"], 
     "INTEGER": ["literal"], 
     "DECIMAL": ["literal"], 
     "DOUBLE": ["literal"], 
     "TRUE": ["literal"], 
     "FALSE": ["literal"], 
     "STRING_LITERAL1": ["literal"], 
     "STRING_LITERAL_LONG1": ["literal"], 
     "STRING_LITERAL2": ["literal"], 
     "STRING_LITERAL_LONG2": ["literal"]}, 
  "xsFacet" : {
     "REGEXP": ["or([stringFacet,numericFacet])"], 
     "LENGTH": ["or([stringFacet,numericFacet])"], 
     "MINLENGTH": ["or([stringFacet,numericFacet])"], 
     "MAXLENGTH": ["or([stringFacet,numericFacet])"], 
     "MININCLUSIVE": ["or([stringFacet,numericFacet])"], 
     "MINEXCLUSIVE": ["or([stringFacet,numericFacet])"], 
     "MAXINCLUSIVE": ["or([stringFacet,numericFacet])"], 
     "MAXEXCLUSIVE": ["or([stringFacet,numericFacet])"], 
     "TOTALDIGITS": ["or([stringFacet,numericFacet])"], 
     "FRACTIONDIGITS": ["or([stringFacet,numericFacet])"]}
},

keywords:/^(BASE|PREFIX|EXTERNAL|OR|AND|NOT|LITERAL|NONLITERAL|IRI|BNODE|LENGTH|MINLENGTH|MAXLENGTH|MININCLUSIVE|MINEXCLUSIVE|MAXINCLUSIVE|MAXEXCLUSIVE|TOTALDIGITS|FRACTIONDIGITS|CLOSED|EXTRA|TRUE|FALSE|START|A)/i ,

punct:/^(=|\(|\)|\.|@|\{|\}|\||;|\*|\+|\?|\^|\[|\]|-|\~|&|\/\/|%|\^\^|\$)/ ,

startSymbol:"shexDoC",
acceptEmpty:true,
}